module.exports = __webpack_public_path__ + "fonts/dxicons.dffa1b6f.woff";